import { FacetValue, FacetValueCount, FacetValues } from "../../../types/Facet";
import { Field } from "../../../types/Field";


export const DisplayModes = {
  FULL: "full",
  COMPACT: "compact",
} as const;

export type DisplayMode = typeof DisplayModes[keyof typeof DisplayModes];


/**
 * Represents the properties for the StringFacet component.
 *
 * @property fullView - Indicates if the facet is in full view mode, meaning all the facet values are displayed.
 */
export interface RenderFacetProps {
    field: Field;
    facetValues: FacetValueCount<FacetValue>[];
    facetSelection: FacetValues<FacetValue> | null;    
    onChangeFacetSelection: (name: string, value: FacetValue, checked: boolean) => void;    
    toggleDisplayMode: (name: string, mode: DisplayMode) => void;
    displayMode: DisplayMode;
    isExecutingSearch: boolean;
}

export interface FacetLogic {
    dataType: string;
    getDefaultSelection?(fieldName: string): FacetValues<FacetValue> | null,
    createFilter(facetSelection: any, field: Field): string,
    createRequest(field: Field): any,
    extractFacetValues(facetName: string, facetValuesFromSearch: any): FacetValueCount<FacetValue>[],
    renderFacet(props: RenderFacetProps): any,
    createUpdatedSelection(facetValue: FacetValue, prevFacetSelection: FacetValues<FacetValue>): FacetValues<FacetValue>,
}